import React from 'react'
import './HomeAbout.css'
import Data from '../../data/Data'


const HomeAbout = () => {
    return (
        <div className='home-about' id="about">
            <h1 className='home-about-heading'>
                ABOUT US
            </h1>
            <div className='home-about-row'>
                <div className='home-about-col'>
                <div className='home-about-img-wrapper'>
                    <img src={Data.aboutImage} alt={'image'} className='home-about-img' />
                </div>
                </div>

                <div className='home-about-col'>
                    <div className='home-about-text-wrapper'>
                        <div className='home-about-top-line'>"{Data.aboutQuote}"</div>
                        <p className='home-about-subtitle'>{Data.aboutText}</p>
                    </div>
                </div> 
            </div>
        </div>
    )
}

export default HomeAbout
